import { transformAddress } from './address';
import { transformCheckoutItemDtos } from './item';
import { transformCreditCardDto } from './credit-card';
import { transformPayInMethodDto } from './pay-in-method';
import { transformCheckoutShipmentDto } from './shipment';
import { transformDeliveryTypesDto } from './delivery-types';
import { transformCurrencyConversionWithMoneyObjectDto } from './currency-conversion';
import { transformCurrencyAmountDto, transformNullableCurrencyAmountDto } from './currency-amount';
import { transformOfflineVerificationDto } from './offline-verification';
export const transformCheckoutExpenseItemDto = _ref => {
  let {
    price,
    discount,
    final_price
  } = _ref;
  return {
    price: transformCurrencyAmountDto(price),
    discount: transformCurrencyAmountDto(discount),
    finalPrice: transformCurrencyAmountDto(final_price)
  };
};
export const transformCheckoutRecommendedPayInMethodDto = _ref2 => {
  let {
    used_before,
    pay_in_method,
    external_card
  } = _ref2;
  return {
    usedBefore: used_before,
    payInMethod: transformPayInMethodDto(pay_in_method),
    externalCard: external_card && transformCreditCardDto(external_card)
  };
};
export const transformCheckoutRecommendedPayInMethodDtos = payInMethods => payInMethods.map(transformCheckoutRecommendedPayInMethodDto);
export const transformCheckoutPayInMethodIncentiveDto = _ref3 => {
  let {
    amount,
    delayed,
    expiry_date
  } = _ref3;
  return {
    isDelayed: delayed,
    expiryDate: expiry_date,
    amount: transformCurrencyAmountDto(amount)
  };
};
export const transformCheckoutPayInMethodPromotionDto = _ref4 => {
  let {
    type,
    amount,
    expiry_date
  } = _ref4;
  return {
    type,
    expiryDate: expiry_date !== null && expiry_date !== void 0 ? expiry_date : null,
    amount: amount ? transformCurrencyAmountDto(amount) : null
  };
};
export const transformCheckoutPayInMethodsConfigDto = _ref5 => {
  let {
    promotion,
    incentive,
    recommended
  } = _ref5;
  return {
    promotion: promotion ? transformCheckoutPayInMethodPromotionDto(promotion) : null,
    incentive: incentive ? transformCheckoutPayInMethodIncentiveDto(incentive) : null,
    recommended: recommended ? transformCheckoutRecommendedPayInMethodDtos(recommended) : null
  };
};
export const transformCheckoutDto = _ref6 => {
  let {
    id,
    items,
    shipment,
    services,
    checksum,
    payment_available,
    seller: {
      is_business
    },
    pricing: {
      base,
      payment,
      shipping,
      sales_tax,
      discount_note,
      shipping_note,
      sales_tax_covered,
      buyer_protection_fee,
      offline_verification_fee,
      conversion
    },
    buyer: {
      card,
      phone_number,
      pay_in_method,
      external_card_code,
      shipment_to_address,
      pay_in_methods_config
    }
  } = _ref6;
  return {
    id,
    checksum,
    paymentAvailable: payment_available,
    items: transformCheckoutItemDtos(items),
    shipment: transformCheckoutShipmentDto(shipment),
    seller: {
      isBusiness: is_business
    },
    buyer: {
      phoneNumber: phone_number !== null && phone_number !== void 0 ? phone_number : null,
      card: card ? transformCreditCardDto(card) : null,
      creditCardId: external_card_code ? "".concat(external_card_code) : null,
      payInMethod: pay_in_method ? transformPayInMethodDto(pay_in_method) : null,
      shipmentToAddress: shipment_to_address ? transformAddress(shipment_to_address) : null,
      payInMethodsConfig: pay_in_methods_config ? transformCheckoutPayInMethodsConfigDto(pay_in_methods_config) : null
    },
    pricing: {
      discountNote: discount_note !== null && discount_note !== void 0 ? discount_note : null,
      shippingNote: shipping_note !== null && shipping_note !== void 0 ? shipping_note : null,
      base: transformCheckoutExpenseItemDto(base),
      shipping: transformCheckoutExpenseItemDto(shipping),
      buyerProtectionFee: transformCheckoutExpenseItemDto(buyer_protection_fee),
      offlineVerificationFee: offline_verification_fee ? transformCheckoutExpenseItemDto(offline_verification_fee) : null,
      isSalesTaxCovered: sales_tax_covered !== null && sales_tax_covered !== void 0 ? sales_tax_covered : null,
      salesTax: sales_tax ? transformNullableCurrencyAmountDto(sales_tax) : null,
      payment: {
        payIn: transformCurrencyAmountDto(payment.pay_in),
        wallet: transformCurrencyAmountDto(payment.wallet)
      },
      conversion: conversion ? transformCurrencyConversionWithMoneyObjectDto(conversion) : null
    },
    services: {
      shipping: services.shipping ? {
        selectedDeliveryType: services.shipping.selected_delivery_type,
        buyerPhoneRequirement: services.shipping.buyer_phone_requirement,
        deliveryTypes: transformDeliveryTypesDto(services.shipping.delivery_types)
      } : null,
      offlineVerification: services.offline_verification ? transformOfflineVerificationDto(services.offline_verification) : null
    }
  };
};